import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { WsreQuickChainComponent } from '../../wsre-quick-chain/wsre-quick-chain.component';
import { WsreQuickFrameComponent } from '../../wsre-quick-frame/wsre-quick-frame.component';
import { WsreQuickIdlerComponent } from '../../wsre-quick-idler/wsre-quick-idler.component';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
//import { WsreQuickChainComponent } from '../../wsre-quick-chain/wsre-quick-chain.component';
@Component({
  selector: 'app-create-new-wsre-inspection',
  templateUrl: './create-new-wsre-inspection.component.html',
  styleUrls: ['./create-new-wsre-inspection.component.scss']
})
export class CreateNewWsreInspectionComponent implements OnInit {

  isShowSecondaryView: boolean = false;
  isInventory:boolean=false;

  constructor(
    public dialogRef: MatDialogRef<CreateNewWsreInspectionComponent>,
    private _router: Router, private _dialog: MatDialog,
  ) {

  }

  ngOnInit() {
  }

  onClickSelectExistingChain() {

    //this.onNoClick()
    //this._router.navigate(['inventory', 1]);
    this.isInventory = false;
    this.onNoClick();
    this.openChain();

  }


  onClickSelectExistingChainFromEquipment() {

    this.onNoClick()
    this._router.navigate(['/wsre-search-on-equipment', 1]);

  }

  onClickSelectExistingIdler() {

    this.onNoClick()
    this._router.navigate(['inventory', 3]);

  }


  onClickSelectExistingIdlerFromEquipment() {

    this.onNoClick()
    this._router.navigate(['/wsre-search-on-equipment', 2]);

  }



  onClickSelectNewChain() {

    this.onNoClick()

    this._router.navigate(['setup-undercarriage/in-inventory', { isWSREInspection: true, isQuick: false }]);
  }

  onNoClick() {
    this.dialogRef.close(true);
  }

  onClickSelectQuickIdlerSetup() {
    this.onNoClick();
    this.open();
  }


  onClickSelectQuickChainSetup() {
    this.onNoClick();
    this._router.navigate(['setup-undercarriage/in-inventory', { isWSREInspection: true, isQuick: true ,systemType:1}]);
  }

  onClickSelectQuickFrameSetup_() {
    this.onNoClick();
    this._router.navigate(['setup-undercarriage/in-inventory', { isWSREInspection: true, isQuick: true , systemType:2}]);
  }


  open() {
    const dialogRef = this._dialog.open(WsreQuickIdlerComponent, {
      panelClass: "removeModalOverflowTest",
      data: {
        // system: item,
        // customer: this.selectedCustomer,
        // customers: this._dropDownLists.customerList,
        // jobsites: this._dropDownLists.jobSiteList
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(changed => {
      if (changed) {
        //this.search();
      }
    });
  }

  onClickSelectExistingFrame() {

    this.isInventory=true;
    this.onNoClick()
    //this._router.navigate(['inventory', 2]);
    this.openFrame();
  }
  onClickSelectQuickFrameSetup()
  {
    this.isInventory=false;
    this.onNoClick();
    this.openFrame();
  }

  
  openFrame() {
    const dialogRef = this._dialog.open(WsreQuickFrameComponent, {
      panelClass: "removeModalOverflowTest",
      data: {
        isInventory:this.isInventory,
        isCreateNew:false,
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(changed => {
      if (changed) {
        //this.search();
      }
    });
  }

  openChain() {
    const dialogRef = this._dialog.open(WsreQuickChainComponent, {
      panelClass: "removeModalOverflowTest",
      data: {
        isInventory: true,
        isCreateNew: false,
        selectedChainSide: 1
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(changed => {
      if (changed) {
        //this.search();
      }
    });
  }
}
